"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterPPTURL = filterPPTURL;
exports.filterIFrameURL = filterIFrameURL;
exports.extractHeight = extractHeight;
function filterPPTURL(address) {
    if (address) {
        if (address.search('google') > -1) {
            var url = /\/edit/.test(address) ? (address.split('/edit')[0]) : address;
            if (!url.includes('embed')) {
                return url + '/embed?start=false&loop=false&delayms=3000';
            }
            return url;
        }
    }
}
function filterIFrameURL(address) {
    var _a;
    var tempElement = document.createElement('div');
    tempElement.innerHTML = address;
    var srcValue = (_a = tempElement.querySelector('iframe')) === null || _a === void 0 ? void 0 : _a.getAttribute('src');
    return srcValue.replace(/“|”/g, ''); // remove any curly quotes from src if there are any
}
function extractHeight(address) {
    var _a;
    var tempElement = document.createElement('div');
    tempElement.innerHTML = address;
    var heightValue = (_a = tempElement.querySelector('iframe')) === null || _a === void 0 ? void 0 : _a.getAttribute('height');
    return heightValue || "450px";
}
